import { EstadoPreventaEnum } from "@/shared/constants";
import { MaterialTransferido } from "../administration";
import { Zone } from "../mantenimiento-operaciones";
import { PermanenciaPlanCorporativo, PlanesCorporativos, TipoPlanCorporativo } from "../planes_corporativos";
import { CondicionVentaCorporativa, IProspectoCorporativo } from "../prospecto/prospecto_corporativo.interface";
import { City, Province } from "../system-settings";

export interface IPreventaCorporativoResp {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  num_pages: string | undefined;
  previous: string | undefined;
  data: IPreventaCorporativo[];
}

///* TODO: interface IPreventaCorporativoForm2 
export interface IPreventaCorporativo {
  id_preventa_coorporativa: string
  codigo: string
  numero_referencia: string
  estado_preventa: string

  ///* Datos del cliente
  nombre_comercial: string
  requiere_backup: boolean
  tipo_servicio_backup: string //'FIBRA OPTICA' | 'INALAMBRICO'
  tipo_backup: string //'CON COSTO' | 'SIN COSTO'
  celular_1?: string
  celular_2?: string
  celular_3?: string

  ///* Detalle de valores
  tipo_servicio_contratar: string //'FIBRA OPTICA' | 'INALAMBRICO'
  capacidad: string
  bonificacion: string

  ///* Datos tecnicos
  servicio_ultima_milla: string //'FIBRA OPTICA' | 'INALAMBRICO'

  ///
  tipo_enlace: string // 'PRINCIAPL' | 'BACKUP'
  es_demo: boolean
  coordenadas: Coordenadas
  direcciones: Direcciones
  tipo_plan: TipoPlanCorporativo
  tipo_servicio: string
  ancho_banda: string
  comparticion: string
  segmento_red: string
  ip_lan: string
  caracteristicas_especiales: CaracteristicasEspeciales
  zona_wifi: boolean
  hotspot: boolean
  router_inalambico: boolean
  vpn: boolean
  espacio_equipos: boolean
  energia_regulada: boolean
  capacidad_para_equipo: boolean
  tipo_puerto_disponible: string
  observaciones: Observaciones
  estado: boolean
  user_create: string
  empresa_create: string
  area_create: string
  departamento_create: string
  canal_venta_create: string
  provincia: string
  provincia_data?: Province
  ciudad: string
  ciudad_data?: City
  zona: string | null
  sector: string | null

  coordenadas_1?: string;
  coordenadas_2?: string;
  coordenadas_3?: string;
  direccion_1?: string;
  direccion_2?: string;
  direccion_3?: string;
  caracteristicas_especiales_aux?: string;

  //* Opcionales de prospecto
  zona_nombre?: string;
  provincia_nombre?: string;
  ciudad_nombre?: string;
  servicio_contratado?: string;
  url_foto_corporativo_cedula_frontal?: string;
  url_foto_corporativo_cedula_posterior?: string;
  url_foto_corporativo_ruc?: string;
  razon_social_representante?: string;
  tecnico_responsable?: string;
  email_tecnico_responsable?: string;
  ejecutivo_comercial: string;
  tipo_cliente: string;
  servicio: string;
  enlace?: string;
  tiene_cdns?: boolean;
  cdns_detalle?: string;
  medio_ultima_milla: string;
  num_ips_publicas: string;
  num_ips_publicas_facturadas: string;
  zona_soterrada?: boolean;
  instalacion_ductos?: boolean;
  seguridad_perimetral?: boolean;
  wifi_gestionado?: boolean;
  cableado_interno?: boolean;
  equipos_adicionales?: MaterialTransferido[];

  coordenada_empresa: string;
  direccion_empresa: string;
  coordenada_cliente: string;
  direccion_cliente: string;
  coordenada_servicio: string;
  direccion_servicio: string;
  coordenada_fusion?: string;
  direccion_fusion?: string;

  motivo_rechazo: string;
  permitir_edicion?: boolean;

  ///*Fk
  prospecto_corporativo_data: IProspectoCorporativo
  prospecto_corporativo: string
  valor_plan?: number
  data_plan_personalizado: DataPlanPersonalizado
  aprueba_plan_personalizado?: boolean
  plan_personalizado?: boolean;
  plan?: string
  sector_tentativo?: string | null
  observacion_rechazo?: any[];

  plan_tvmax?: PlanTVMAX_BD | null

  preventa_aprobada_factibilidad?: boolean

  fecha_inicio_evento?: Date;
  fecha_fin_evento?: Date;
  fecha_inicio_plan?: Date;
  fecha_fin_plan?: Date;

  fecha_modificacion?: string
  fecha_creacion?: string
  numero_seguimiento?: number

  // Historial de aprobaciones
  historial_aprobacion_data?: IHistorialAprobacionCorporativa[]
  user_creador_data?: IUserAprobacionData
  user_aprobador_prefactibilidad_data?: IUserAprobacionData
}

// Interface para el historial de aprobaciones corporativas
export interface IHistorialAprobacionCorporativa {
  id_historial_aprobacion: string
  codigo: string
  numero_referencia: string
  user: string
  tipo_accion: 'CREACION_PREVENTA' | 'APROBACION_PREFACTIBILIDAD' | 'CREACION_FACTIBILIDAD' | 'APROBACION_FACTIBILIDAD'
  preventa_corporativa?: string
  factibilidad_corporativa?: string
  empresa?: string
  area?: string
  departamento?: string
  canal_venta?: string
  ip?: string
  observaciones?: string
  fecha_creacion?: string
}

// Interface para datos del usuario en historial de aprobaciones
export interface IUserAprobacionData {
  username?: string
  first_name?: string
  last_name?: string
  email?: string
  nombres?: string
  apellidos?: string
  cedula?: string
  celular?: string
}

export interface IPreventaCorporativoParams extends Partial<IPreventaCorporativo> {
  page?: number
  page_size?: number
}
export interface IPreventaCorporativoForm extends
  Omit<IPreventaCorporativo,
    'id_preventa_coorporativa' |
    'codigo' |
    'numero_referencia' |
    'estado_preventa' |
    'estado' |
    // 'prospecto_data' |
    'user_create' |
    'empresa_create' |
    'area_create' |
    'departamento_create' |
    'canal_venta_create' |
    // 'coordenadas' |
    // 'direcciones' |
    'caracteristicas_especiales' |
    // 'observaciones' |
    'codigo'
  // 'prospecto' 
  > {

  ///*aux
  coordenada_fusion: string
  coordenada_servicio: string
  coordenada_empresa: string

  direccion_fusion: string
  direccion_servicio: string
  direccion_empresa: string

  caracteristica_cliente?: string
  observacion_vendedor?: string

  segmentacion?: string
  puntaje_score?: number | string;
  puntaje_score_empresa?: number | string;
  puntaje_score_sobreendeudamiento?: number | string
  tipo_identificacion?: string
  identificacion?: string;
  razon_social?: string;

  sectores_options?: any;
  zona_sector?: string;
}

export interface IPreventaCorporativoForm2 {
  id_preventa_coorporativa?: string;
  estado_preventa?: EstadoPreventaEnum

  // tipo_cliente: string;
  // ejecutivo_comercial: string;
  coordenada_empresa: string;
  direccion_empresa: string;
  // ===========================================================================
  // estas ya no
  // ===========================================================================
  coordenada_cliente: string;
  direccion_cliente: string;
  // ===========================================================================
  // estas reemplazan a las de arriba
  // ===========================================================================
  coordenada_fusion: string;
  direccion_fusion: string;

  coordenada_servicio: string;
  direccion_servicio: string;
  // servicio: string;
  // email_tecnico_responsable: string;
  tipo_puerto_disponible: string;
  // medio_ultima_milla: string;
  bonificacion: string;
  // num_ips_publicas: string;
  // num_ips_publicas_facturadas: string;
  tipo_enlace: string;
  ejecutivo_comercial: string;
  medio_ultima_milla: string;
  num_ips_publicas: string;
  num_ips_publicas_facturadas: string;
  tipo_plan: TipoPlanCorporativo;

  //OPCIONALES
  codigo?: string;
  numero_referencia?: string;
  capacidad?: string;
  tipo_servicio?: string;
  energia_regulada?: boolean;
  espacio_equipos?: boolean;
  requiere_backup?: boolean;

  prospecto_data?: IProspectoCorporativo;

  razon_social?: string;
  nombre_comercial?: string;
  identificacion?: string;
  celular?: string;
  celular_1?: string;
  celular_2?: string;
  telefono?: string;

  zona?: string;
  sector?: string;
  observaciones?: any;
  observacion_vendedor?: string;
  observacion_prefactibilidad?: string;
  observacion_enlace_backup?: string;
  observacion_factibilidad?: string;
  observacion_inspeccion_factibilidad?: string;
  observacion_rechazo?: any[],

  zona_data?: Zone
  zona_nombre?: string;
  provincia_nombre?: string;
  ciudad_nombre?: string;
  servicio_contratado?: string;
  url_foto_corporativo_cedula_frontal?: string;
  url_foto_corporativo_cedula_posterior?: string;
  url_foto_corporativo_ruc?: string;
  razon_social_representante?: string;
  tecnico_responsable?: string;
  email_tecnico_responsable?: string;
  plan?: string;
  plan_data?: PlanesCorporativos;
  tipo_cliente?: string;
  servicio: string;
  enlace?: string;
  tiene_cdns?: boolean;
  cdns_detalle?: string;
  zona_soterrada?: boolean;
  instalacion_ductos?: boolean;
  seguridad_perimetral?: boolean;
  fibra_oscura?: boolean;
  wifi_gestionado?: boolean;
  cableado_interno?: boolean;
  plan_tvmax_bool?: boolean;

  check_equipos_adicionales?: boolean;
  equipos_adicionales?: MaterialTransferido[];
  //---PLANES
  entidad_bancaria?: string;
  entidad_bancaria_instalacion?: string;
  banco_emisor?: string;
  nombre_contador?: string;
  fecha_caducidad_tarjeta?: string;
  fecha_caducidad_tarjeta_instalacion?: string;
  tipo_tarjeta?: string;
  tipo_cuenta?: string;//ahorros - corriente
  tipo_cuenta_instalacion?: string;//ahorros - corriente
  metodo_pago_mensualidad?: string;
  metodo_pago_instalacion?: string;
  num_cuenta?: string;

  velocidad_total?: string;
  disponibilidad?: string;

  es_demo: boolean
  //para pagos
  id_prospecto_corporativo?: string;
  forma_pago?: string;
  tipo_contrato?: string;
  tipo_contrato_instalacion?: string;
  codigo_forma_pago?: string;
  entidad_financiera?: string;
  tipo_cuenta_bancaria?: string;
  cooperativa?: string;
  cooperativa_instalacion?: string;
  numero_cuenta?: string;
  numero_cuenta_instalacion?: string;
  tarjeta_fecha_caducidad?: string;
  numero_tarjeta?: string;
  numero_tarjeta_instalacion?: string;
  valor_instalacion_iva?: number;
  valor_instalacion?: number;
  valor_instalacion_total?: number;


  tarjeta?: string;
  costo_valor_ip_facturado?: number;
  valor_plan?: number;
  submascara_red?: string;


  es_android_tv?: boolean;
  numero_cuotas_android_tv?: number;
  precio_android_tv?: number;
  numero_cantidad_android_tv?: number;

  ips?: IPsSeleccionadasFormato[];

  prospecto_corporativo?: string
  prospecto_corporativo_data?: IProspectoCorporativo;


  puntaje_score?: number;
  puntaje_score_sobreendeudamiento?: number;
  puntaje_score_empresa?: number;
  segmentacion?: string;
  actividad_economica_principal?: string;

  costo_seguridad_perimetral?: number;
  costo_wifi_gestionado?: number;
  costo_cableado_interno?: number;
  costo_plan_tvmax?: number;
  costo_fibra_oscura?: number;

  lat?: number;
  lng?: number;

  observacion_preventa?: string;
  plan_personalizado?: boolean;
  aprueba_plan_personalizado?: boolean;
  data_plan_personalizado?: DataPlanPersonalizado;
  //*
  provincia?: string
  ciudad?: string
  tiene_cobertura?: boolean;
  sector_tentativo?: string;

  provincia_data?: Province
  ciudad_data?: City
  preventa_corporativa_data?: IPreventaCorporativo

  servicio_ultima_milla?: string
  tipo_servicio_contratar?: string
  tipo_servicio_backup?: string

  permitir_edicion?: boolean
  condicion_venta?: CondicionVentaCorporativa | null | string

  email?: string;
  persona_contacto?: string;
  direccion?: string;

  codigo_plan_tvmax?: string;
  usuarios_plan_tvmax?: number
  valor_total_plan_tvmax?: number
  plan_tvmax?: PlanTVMAX_BD | null
  usuarios_plan_tvmax_min?: number;
  usuarios_plan_tvmax_max?: number;

  ancho_banda?: string;
  preventa_aprobada_factibilidad?: boolean


  fecha_inicio_evento?: Date;
  fecha_fin_evento?: Date;
  fecha_inicio_plan?: Date;
  fecha_fin_plan?: Date;

  aumentar_disponibilidad?: boolean

  preventas_corpo_antiguas?: any

  motivo_rechazo?: any

  documentos_guardados?: boolean
  documentos?: any[]

  servicios_adicionales?: any[]
  plan_corporativo_backup?: string;
  numero_seguimiento?: number;
  datos_preventa_completados?: boolean;

  // Campos de Información Adicional (PRV-002)
  area_responsable_inspeccion?: 'FIBRA' | 'RADIO' | null;
  url_archivo_inspeccion_adicional?: string | null;
  url_archivo_propuesta_tecnica?: string | null
}

export interface PlanTVMAX_BD {
  codigo_plan_tvmax: string;
  nombre_plan_tvmax: string;
  seniales_plan_tvmax: number;
  costo_plan_tvmax: number;
  usuarios_plan_tvmax: number;
  min_usuarios: number;
  max_usuarios: number;
}

export interface IPlanesTVMAX {
  codigo: string;
  nombre: string;
  seniales: number;
  valor: number;
  min_usuarios: number;
  max_usuarios: number;
}
export const PLANESTVMAX_OPTIONS: IPlanesTVMAX[] = [
  {
    codigo: "BASICO-1",
    nombre: "BÁSICO - 1 A 500 USUARIOS",
    valor: 1.5,
    seniales: 40,
    min_usuarios: 1,
    max_usuarios: 500,
  },
  {
    codigo: "BASICO-2",
    nombre: "BÁSICO - 500 A 1000 USUARIOS",
    valor: 1.25,
    seniales: 40,
    min_usuarios: 500,
    max_usuarios: 1000,
  },
  {
    codigo: "BASICO-3",
    nombre: "BÁSICO - 1000 USUARIOS EN ADELANTE",
    valor: 1,
    seniales: 40,
    min_usuarios: 1000,
    max_usuarios: 9999,
  },

  {
    codigo: "PLUS-1",
    nombre: "PLUS - 1 A 500 USUARIOS",
    valor: 3,
    seniales: 45,
    min_usuarios: 1,
    max_usuarios: 500,
  },
  {
    codigo: "PLUS-2",
    nombre: "PLUS - 500 A 1000 USUARIOS",
    valor: 2.75,
    seniales: 45,
    min_usuarios: 500,
    max_usuarios: 1000,
  },
  {
    codigo: "PLUS-3",
    nombre: "PLUS - 1000 USUARIOS EN ADELANTE",
    valor: 2.5,
    seniales: 45,
    min_usuarios: 1000,
    max_usuarios: 9999,
  },

  {
    codigo: "PREMIUM-1",
    nombre: "PREMIUM - 1 A 500 USUARIOS",
    valor: 3.5,
    seniales: 53,
    min_usuarios: 1,
    max_usuarios: 500,
  },
  {
    codigo: "PREMIUM-2",
    nombre: "PREMIUM - 500 A 1000 USUARIOS",
    valor: 3.25,
    seniales: 53,
    min_usuarios: 500,
    max_usuarios: 1000,
  },
  {
    codigo: "PREMIUM-3",
    nombre: "PREMIUM - 1000 USUARIOS EN ADELANTE",
    valor: 3,
    seniales: 53,
    min_usuarios: 1000,
    max_usuarios: 9999,
  },

  {
    codigo: "GOLD-1",
    nombre: "GOLD - 1 A 500 USUARIOS",
    valor: 10.99,
    seniales: 67,
    min_usuarios: 1,
    max_usuarios: 500,
  },
  {
    codigo: "GOLD-2",
    nombre: "GOLD - 500 A 1000 USUARIOS",
    valor: 10.49,
    seniales: 67,
    min_usuarios: 500,
    max_usuarios: 1000,
  },
  {
    codigo: "GOLD-3",
    nombre: "GOLD - 1000 USUARIOS EN ADELANTE",
    valor: 9.99,
    seniales: 67,
    min_usuarios: 1000,
    max_usuarios: 9999,
  },
]





export interface DataPlanPersonalizado {
  nombre_personalizado?: string;
  tipo_plan_personalizado?: TipoPlanCorporativo;
  permanencia_personalizado?: PermanenciaPlanCorporativo | string;
  costo_instalacion_personalizado?: number;
  valor_personalizado?: number;
  capacidad_personalizado?: string;

  bonificacion_personalizado?: number;
}


export type IPsSeleccionadasFormato = {
  ip: string
  estado: boolean
}

export interface Coordenadas {
  coordenada_cliente: string
  coordenada_servicio: string
  coordenada_empresa: string
}

export interface Direcciones {
  direccion_1: string
  direccion_2?: string | null
  direccion_3?: string | null
  direccion_cliente: string
  direccion_servicio: string
  direccion_empresa: string

}

export interface CaracteristicasEspeciales {
  caracteristica_cliente: string
}

export interface Observaciones {
  [key: string]: string | undefined
  observacion_vendedor?: string
  observacion_prefactibilidad?: string
  observacion_enlace_backup?: string
  observacion_preventa?: string
}
